import React from "react";

import { useLocalContent } from "~/sdks/LocalContent/context";

import { XIcon } from "@phosphor-icons/react";

import * as styles from "./styles";

export function Header({ title }: { title: string }) {
  const { handleMarkerClick } = useLocalContent();

  const onClose = () => {
    handleMarkerClick();
  };

  return (
    <div className={styles.container}>
      {title}{" "}
      <button
        onClick={onClose}
        data-testid="poi-popup-content-header-close-button"
      >
        <XIcon className={styles.icon} weight="bold" />
      </button>
    </div>
  );
}
